import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import React, { ReactElement, useEffect, useState } from "react";

import MediaTypeIcon from "../../components/media-format/media-type-icon";
import { Asset } from "../../generated/gql/graphql";
import useAssets from "../../hooks/query/asset/use-assets";

type Props = {
  asset: Asset;
};

export default function AssetVersionSelector(props: Props): ReactElement {
  const { asset } = props;

  const [stackVersions, setStackVersions] = useState<Asset[]>([]);

  const { data, loading, error } = useAssets({
    filter: {
      parentId: {
        eq: asset.parentId,
      },
    },
    // orderBy: [
    //     {
    //         oder_index: Sort.Desc
    //     }
    // ],
  });

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!data || !data.assets) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setStackVersions(data.assets.items);
  }, [data]);

  return (
    <FormControl style={{ minWidth: 150 }} size="small">
      <InputLabel className="text-[14px]">Stack versions</InputLabel>
      <Select
        className="border-0 rounded-[15px] text-[14px] text-left mr-15 max-w-full"
        // onChange={() => {}}
        value={stackVersions}
        label="Stack versions"
      >
        {stackVersions.map((item: Asset, index: number) => (
          <MenuItem
            className="max-w-[800px] block"
            key={item.id as string}
            value={item.id as string}
          >
            <Tooltip title={item.name} followCursor>
              <div className="truncate">
                <MediaTypeIcon
                  asset={item}
                  classes="text-[25px] max-w-[25px] max-h-[25px] mr-10 object-contain inline-block"
                />
                v.{index + 1}: {item.name}
              </div>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
